import classnames from 'classnames';
import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {NavLink} from 'react-router-dom';
import {Navbar} from 'reactstrap';
import CloseIcon from '../../../../shared/components/icons/CloseIcon';
import MenuIcon from '../../../../shared/components/icons/MenuIcon';
import BrandHeader from '../../../../shared/ui/BrandHeader';
import CommonNav from './CommonNav';
import {Storage} from "../../../../shared/services/aws";
import departmentSettingsSelectors from "../../../store/department-settings/selectors";
import Checkbox from "../../../../shared/forms/Checkbox";

class NavDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOffcanvasShowing: false,
      ftoGuidelinesLink: null,
      isDarkMode: Boolean(localStorage.getItem('isDarkMode'))
    };
    this.resetLink.bind(this);
    this.navBar = React.createRef();
  }

  get navForUserScope() {
    if (!this.props.isAuthenticated) {
      return null;
    }
    switch (this.props.userContext.scope) {
      case 'chief':
      case 'cstaff':
        return (
          <CommonNav ftoGuidelinesLink={this.state.ftoGuidelinesLink}>
            {this.props.canReviewOpenReports &&
              <NavLink activeClassName="active" className="navigation-item" to="/reports">
                <i className="fa fa-paperclip"/> Review Open Reports
              </NavLink>}
            <NavLink activeClassName="active" className="navigation-item" to="/active-ftos">
              <i className="fa fa-user-secret"/> View All {this.props.ftoShortLabel}s
            </NavLink>
            <NavLink activeClassName="active" className="navigation-item" to="/task-training">
              <i className="fa fa-tasks"/> {this.props.oitShortLabel} Task Details
            </NavLink>
          </CommonNav>
        );
      case 'ftoc':
        return (
          <CommonNav ftoGuidelinesLink={this.state.ftoGuidelinesLink}>
            {this.props.canReviewOpenReports &&
            <NavLink activeClassName="active" className="navigation-item" to="/reports">
              <i className="fa fa-paperclip"/> Review Open Reports
            </NavLink>}

            <NavLink activeClassName="active" className="navigation-item" to="/active-ftos">
              <i className="fa fa-user-secret"/> Active {this.props.ftoShortLabel}s
            </NavLink>

            {this.props.canAssignSchedules &&
            <NavLink activeClassName="active" className="navigation-item" to="/schedule-reports">
              <i className="fa fa-calendar-check-o" /> Assign schedules
            </NavLink>}

            {this.props.areTestsEnabled && <NavLink activeClassName="active" className="navigation-item" to="/schedule-tests">
              <i className="fa fa-calendar-check-o"/> Assign tests
            </NavLink>}

            {this.props.canViewTaskProgress &&
            <NavLink activeClassName="active" className="navigation-item" to="/task-training">
              <i className="fa fa-tasks"/> {this.props.oitShortLabel} Tasks
            </NavLink>}

            <NavLink activeClassName="active" className="navigation-item" to="/print-forms">
              <i className="fa fa-print" /> View - Print blank forms
            </NavLink>

            {this.props.areTestsEnabled && <NavLink activeClassName="active" className="navigation-item" to="/test-templates">
              <i className="fa fa-list-alt"/> Manage Test Templates
            </NavLink>}

            <NavLink
              className="navigation-item"
              to="/users"
            >
              <i className="fa fa-users"/> Manage Users
            </NavLink>

          </CommonNav>
        );
      case 'sup':
        return (
          <CommonNav ftoGuidelinesLink={this.state.ftoGuidelinesLink}>
            {this.props.canReviewOpenReports &&
            <NavLink activeClassName="active" className="navigation-item" to="/reports">
              <i className="fa fa-paperclip"/> Review Open Reports
            </NavLink>}

            <NavLink activeClassName="active" className="navigation-item" to="/active-ftos">
              <i className="fa fa-user-secret"/> Active {this.props.ftoShortLabel}s
            </NavLink>

            {this.props.canAssignSchedules &&
            <NavLink activeClassName="active" className="navigation-item" to="/schedule-reports">
              <i className="fa fa-calendar-check-o" /> Assign schedules
            </NavLink>}

            {this.props.areTestsEnabled && <NavLink activeClassName="active" className="navigation-item" to="/schedule-tests">
              <i className="fa fa-calendar-check-o"/> Assign tests
            </NavLink>}

            {this.props.canViewTaskProgress &&
            <NavLink activeClassName="active" className="navigation-item" to="/task-training">
              <i className="fa fa-tasks"/> {this.props.oitShortLabel} Tasks
            </NavLink>}

            <NavLink activeClassName="active" className="navigation-item" to="/print-forms">
              <i className="fa fa-print" /> View - Print blank forms
            </NavLink>

            {this.props.areTestsEnabled && <NavLink activeClassName="active" className="navigation-item" to="/test-templates">
              <i className="fa fa-list-alt"/> Manage Test Templates
            </NavLink>}


          </CommonNav>
        );
      case 'depadmin':
        return (
          <CommonNav ftoGuidelinesLink={this.state.ftoGuidelinesLink}>
            <NavLink activeClassName="active" className="navigation-item" to="/reports">
              <i className="fa fa-paperclip" /> Review Open Reports
            </NavLink>

            <NavLink activeClassName="active" className="navigation-item" to="/active-ftos">
              <i className="fa fa-user-secret"/> Active {this.props.ftoShortLabel}s
            </NavLink>

            <div className="navigation-separator" />

            { this.isMasterDepartment ? (
              <NavLink activeClassName="active" className="navigation-item" to="/sub-departments">
                <i className="fa fa-building-o" /> Manage Divisions
              </NavLink>
            ): null}

            <NavLink activeClassName="active" className="navigation-item" to="/department-settings">
              <i className="fa fa-suitcase" /> Department Settings
            </NavLink>

            <NavLink activeClassName="active" className="navigation-item" to="/forms">
              <i className="fa fa-paperclip" /> Manage Forms
            </NavLink>

            <NavLink activeClassName="active" className="navigation-item" to="/tags">
              <i className="fa fa-tag" /> Manage Tags
            </NavLink>

            <NavLink activeClassName="active" className="navigation-item" to="/task-groups">
              <i className="fa fa-tasks" /> Manage Task Groups
            </NavLink>

            <NavLink activeClassName="active" className="navigation-item" to="/training-programs">
              <i className="fa fa-car" /> Manage Training Programs
            </NavLink>

            {this.props.areTestsEnabled && <NavLink activeClassName="active" className="navigation-item" to="/test-templates">
              <i className="fa fa-list-alt"/> Manage Test Templates
            </NavLink>}

            <NavLink
              className="navigation-item"
              to="/users"
            >
              <i className="fa fa-users"/> Manage Users
            </NavLink>

            <NavLink
              className="navigation-item"
              to="/packager"
            >
              <i className="fa fa-briefcase"/> Export {this.props.oitShortLabel} data
            </NavLink>
          </CommonNav>
        );
      case 'fto':
        return (
          <CommonNav ftoGuidelinesLink={this.state.ftoGuidelinesLink}>
            {/*
              <AddReportMenu />
            */}
            {(this.props.userContext.hasScope(['fto']) && this.props.settings && this.props.settings.allowFtoToScheduleReports) &&
            <NavLink activeClassName="active" className="navigation-item" to="/schedule-reports">
              <i className="fa fa-calendar-check-o"/> Assign schedules
            </NavLink>
            }
            {this.props.areTestsEnabled && <NavLink activeClassName="active" className="navigation-item" to="/schedule-tests">
              <i className="fa fa-calendar-check-o"/> Assign tests
            </NavLink>}
            {this.props.areTestsEnabled && <NavLink activeClassName="active" className="navigation-item" to="/test-templates">
              <i className="fa fa-list-alt"/> Manage Test Templates
            </NavLink>}
            <NavLink activeClassName="active" className="navigation-item" to="/print-forms">
              <i className="fa fa-print"/> View - Print blank forms
            </NavLink>
          </CommonNav>
        );
      case 'oit':
        return <CommonNav ftoGuidelinesLink={this.state.ftoGuidelinesLink}/>;
      default:
        return null;
    }
  }

  // ----------------------
  // Computed
  // ----------------------

  setFTOGuidelinesLink(key) {
    Storage.get(`${key}`)
      .then(result => {
        this.setState({
          ftoGuidelinesLink: result
        })
      })
      .catch((err) => {
      });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.settings && nextProps.settings.ftoGuidelines) {
      this.setFTOGuidelinesLink(nextProps.settings.ftoGuidelines);
    }
  }

  componentDidMount() {
    this.navBar.current.addEventListener('click', () => {
      this.closeOffcanvas()
    }, false)
    if (this.state.isDarkMode) {
      document.body.classList.add('dark-mode')
    }
  }

  get offcanvasClasses() {
    return classnames('main-navigation-sidebar-mobile', {
      'd-lg-none': true,
      'd-xl-none': true,
      offcanvas: true,
      'show-offcanvas': this.state.isOffcanvasShowing,
    });
  }

  get overlayClasses() {
    return classnames({
      'd-md-none': true,
      'd-lg-none': true,
      'd-xl-none': true,
      'offcanvas-overlay': true,
      'show-overlay': this.state.isOffcanvasShowing,
    });
  }

  get isMasterDepartment() {
    return !this.props.subDepartments.find(d => d.guid === this.props.userContext.departmentGuid) || !this.props.subDepartments.find(d => d.guid === this.props.userContext.departmentGuid).parent_guid
  }
  // ----------------------
  // Methods
  // ----------------------

  closeOffcanvas() {
    this.setState({ isOffcanvasShowing: false });
  }

  openOffcanvas() {
    this.setState({ isOffcanvasShowing: true });
  }

  resetLink() {
    return this.props.history && this.props.history.push('/users');
  }

  setDarkmode(e) {
    this.setState({
      isDarkMode: e.target.checked
    });

    if (e.target.checked) {
      document.body.classList.add('dark-mode');
      localStorage.setItem('isDarkMode', true.toString())
    } else {
      document.body.classList.remove('dark-mode');
      localStorage.removeItem('isDarkMode')
    }
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        <div className={this.offcanvasClasses} ref={this.navBar}>
          <Navbar className="d-flex justify-content-end close-navbar">
            <CloseIcon onClose={() => this.closeOffcanvas()} />
          </Navbar>
          <BrandHeader dark/>
          <div className="dark-mode-switch">
            <Checkbox label={'Dark mode'} checked={this.state.isDarkMode} onChange={(e) => this.setDarkmode(e)}/>
          </div>
          <div className="scrollable">
            {this.navForUserScope}
          </div>
        </div>
        {/* eslint-disable-next-line */}
        <div
          className={this.overlayClasses}
          onClick={() => this.closeOffcanvas()}
        />
        <Navbar className="d-lg-none d-xl-none open-navbar">
          <MenuIcon onOpen={() => this.openOffcanvas()} />
        </Navbar>

        <div className="main-navigation-sidebar">
          <BrandHeader dark />
          <div className="dark-mode-switch">
            <Checkbox label={'Dark mode'} checked={this.state.isDarkMode} onChange={(e) => this.setDarkmode(e)}/>
          </div>
          <div className="scrollable">{this.navForUserScope}</div>
        </div>
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.common.userContext.isAuthenticated,
    userContext: state.common.userContext,
    settings: state.departmentSettings.settings,
    subDepartments: state.subDepartments.list,
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
    canViewTaskProgress: departmentSettingsSelectors.canViewTaskProgress(state),
    canAssignSchedules: departmentSettingsSelectors.canAssignSchedules(state),
    canReviewOpenReports: departmentSettingsSelectors.canReviewOpenReports(state),
    areTestsEnabled: departmentSettingsSelectors.areTestsEnabled(state),
  };
};

export default connect(mapStateToProps, null)(NavDrawer);
